export const CHARTCOLORS = {
    COLOR1: "#F98B23",
    COLOR2: "#DB931F",
    COLOR3: "#F3BA2F",
    COLOR4: "#DBB91F",
    COLOR5: "#F9E823",
    BLACK: "#000",
    WHITE: "#fff",
}